import React from "react";
import { Image } from "../../atoms/Image";
import classNames from "classnames";
import styles from "./ProductListTableComponents.module.scss";

const stringRenderer = ({ className, value }) => (
  <div className={classNames(className, styles.cellText)}>{value}</div>
);

const imageRenderer = ({ className, value, row: { values } }) => (
  <Image src={value} alt={values.name} size={36} circle noShadow />
);

const renderers = {
  string: stringRenderer,
  image: imageRenderer
};

const Cell = () => ({ cell, ...props }) => {
  const format = cell.column.dataKey || "string";
  const renderer = renderers[format] || renderers.string;

  return renderer({ ...cell, ...props });
};

export default Cell;
